export enum CUSTOM_REPORT_REQUEST_ID_LIST {
    POST_CUSTOM_REPORT = 'POST_CUSTOM_REPORT',
    GET_CUSTOM_REPORTS = 'GET_CUSTOM_REPORTS',
    DOWNLOAD_CUSTOM_REPORT = 'DOWNLOAD_CUSTOM_REPORT',
}

export const CUSTOM_REPORT_STATUS = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
} as const;

export enum CUSTOM_REPORT_TYPE {
    STM = 'STM',
    TNV = 'TNV',
}

export const CUSTOM_REPORT_STATUS_FILTER_OPTIONS = [
    { id: CUSTOM_REPORT_STATUS.COMPLETED,  label: 'main.custom-report.status.COMPLETED' },
    { id: CUSTOM_REPORT_STATUS.PROCESSING, label: 'main.custom-report.status.PROCESSING' },
    { id: CUSTOM_REPORT_STATUS.PENDING,    label: 'main.custom-report.status.PENDING' },
    { id: CUSTOM_REPORT_STATUS.FAILED,     label: 'main.custom-report.status.FAILED' },
] as const;

export const CUSTOM_REPORT_ALERT_DURATION_MS = 3000;
